var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.26801 6.26801 0 14 0H17.5658C25.2977 0 31.5658 6.26801 31.5658 14V14C31.5658 21.732 25.2977 28 17.5658 28H14C6.26802 28 0 21.732 0 14V14Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0515 9.28571C17.0515 9.72051 16.8356 10.1049 16.5053 10.3376C17.3026 14.7779 20.4314 15.2508 21.594 11.3077C21.4337 11.1147 21.3373 10.8667 21.3373 10.5962C21.3373 9.98085 21.8362 9.48196 22.4516 9.48196C23.067 9.48196 23.5659 9.98085 23.5659 10.5962C23.5659 11.0878 23.2476 11.505 22.8059 11.653L22.3465 19.191C22.3465 19.191 20.2563 20 15.7635 20C11.2708 20 9.18058 19.191 9.18058 19.191L8.72168 11.6394C8.29999 11.4806 8 11.0735 8 10.5962C8 9.98084 8.49888 9.48196 9.11429 9.48196C9.72969 9.48196 10.2286 9.98084 10.2286 10.5962C10.2286 10.8826 10.1206 11.1437 9.94311 11.341C11.1134 15.2502 14.2192 14.7648 15.0161 10.3304C14.6915 10.0971 14.48 9.71608 14.48 9.28571C14.48 8.57563 15.0557 8 15.7657 8C16.4758 8 17.0515 8.57563 17.0515 9.28571Z",
    fill: "#FFBA68"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.8a6c9126.svg";
export { ForwardRef as ReactComponent };